import { createAction } from "@reduxjs/toolkit";

export const activateRetry = createAction<boolean>('retry/activate');